var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(
      _vm.$route.name != 'product' &&
        _vm.$route.name != 'rebate' &&
        _vm.$route.name != 'ewallet' &&
        _vm.$route.name != 'pulsa' &&
        _vm.$route.name != 'poincash' &&
        _vm.$route.name != 'login' &&
        _vm.$route.name != 'productdetail' &&
        _vm.$route.name != 'RebateDetails' &&
        _vm.$route.name != 'pointcashdetails' &&
        _vm.$route.name != 'PulsaDetails' &&
        _vm.$route.name != 'EwalletDetails' &&
        _vm.$route.name != 'SuccessPage'
    )?_c('div',[_c('Navigasi')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }